import { createWagerTicket } from './wagerTicket';
import { createDepositTicket } from './depositTicket';
import { printer } from '@/utils/printer';
import { convertTimeToCTAndFormatPrint } from '@/views/history/history-utils';
import store from '@/store';
import router from '@/router';
import sumBy from 'lodash/sumBy';
import i18n from '@/utils/i18n';
import snq from 'snq';

/*
  PRINT DEPOSIT TICKET
  DECIDE IF TABLET OR ELECTRON
  IF ELECTRON, USE CONNECTED USB PRINTER
  IF TABLET, USE ANDROID JS BRIDGE TO INVOKE BLUETOOTH PRINTER
*/
export const PRINTERS = {
  StarTSP100: 'Star TSP100',
  Default: 'default',
  EpsonTMP80: 'Epson TM-P80',
  PoslineIT1260: 'Posline IT1260',
};

/*
  PRINT WAGER TICKET
  DECIDE IF TABLET OR ELECTRON
  IF ELECTRON, USE CONNECTED USB PRINTER
  IF TABLET, USE ANDROID JS BRIDGE TO INVOKE BLUETOOTH PRINTER
*/
/**
 * @param clientType
 * @param ticketJson
 * @param lang
 * @param callback
 * @param isNewResponse response is different :( . There is no reprint zebra right now. Have to map...
 */
export function printWagerTicket({
  clientType,
  ticketJson,
  lang,
  callback,
  isNewResponse,
  reprintTicket,
  hideBarcode,
  isTestTicket
}) {
  if(isTestTicket) {
    router.push({
      name: 'clerk-ticket-test',
      query: { ...ticketJson, currentRouteNameToRedirect: router.currentRoute.name, isTestTicket: true },
    });
    return;
  }
  if (!ticketJson.bets) {
    console.error('ticketJson.bets empty', ticketJson);
    return;
  }
  if (!ticketJson.barcode) {
    console.error('ticketJson.barcode empty', ticketJson);
    return;
  }
  ticketJson.header = store.state.settings.terminalInfo.location.ticket_header;
  ticketJson.footer = store.state.settings.terminalInfo.location.ticket_footer;
  ticketJson.brand_description = 'SPORTSBOOK & KIOSK & WEB';
  ticketJson.time_stamp = convertTimeToCTAndFormatPrint(new Date());

  //ticketJson.total_risk = sumBy(ticketJson.bets, row => parseFloat(row.wager_header.risk)).toFixed(2);
  ticketJson.total_risk = 50;
  //ticketJson.total_win = sumBy(ticketJson.bets, row => parseFloat(row.wager_header.win)).toFixed(2);
  ticketJson.total_win = 20;

  ticketJson.lang_warning = i18n.t('PrintTemplate.WagerTicket.zpl.warning');
  ticketJson.lang_bet = i18n.t('PrintTemplate.WagerTicket.zpl.bet');
  ticketJson.lang_win = i18n.t('PrintTemplate.WagerTicket.zpl.win');
  ticketJson.lang_risk = i18n.t('PrintTemplate.WagerTicket.zpl.risk');
  ticketJson.lang_bet_win = i18n.t('PrintTemplate.WagerTicket.zpl.bet_win');
  ticketJson.lang_bet_risk = i18n.t('PrintTemplate.WagerTicket.zpl.bet_risk');
  ticketJson.term = i18n.t('PrintTemplate.WagerTicket.zpl.term', {
    domain: window.location.hostname,
  });
  ticketJson.key = lang;
  ticketJson.lang_winTax = i18n.t('Total Tax');
  ticketJson.lang_winFee = i18n.t('Total Fee');

  ticketJson.winTax = 0;
  ticketJson.winFee = 0;

  const currentRouteNameToRedirect = router.currentRoute.name;

  if (clientType === 'ELECTRON') {
    store.dispatch('betSlip/setPrinting', true);
    const printer_model = snq(() => store.state.settings.terminalInfo.printer.printer_model);

    if (!store.state.settings.terminalInfo.printer || printer_model === PRINTERS.Default) {
      callback({ success: true });
      router.push({
        name: 'clerk-ticket',
        query: { ...ticketJson, currentRouteNameToRedirect, isNewResponse: isNewResponse, reprintTicket, hideBarcode },
      });
    } else if (
      printer_model === PRINTERS.StarTSP100 ||
      printer_model === PRINTERS.EpsonTMP80 ||
      printer_model === PRINTERS.PoslineIT1260
    ) {
      callback({ success: true });
      router.push({
        name: 'clerk-ticket',
        query: { ...ticketJson, currentRouteNameToRedirect, isNewResponse: isNewResponse, reprintTicket, hideBarcode },
      });
    } else {
      // ZEBRA
      console.log('starting to print via usb printer');
      const ticket = createWagerTicket(ticketJson);
      console.log('wager ticket:');
      console.log(ticket);
      printer.print(ticket, callback);
      store.dispatch('settings/setReprintModal', {
        show: true,
        scanCode: ticketJson.scan_code,
      });
    }
  } else if (clientType === 'ANDROID_TABLET') {
    console.log('starting to print via android tablet');
    if (typeof Epos_Android_Interface != 'undefined') {
      if (Epos_Android_Interface.printWagerTicket != 'undefined') {
        Epos_Android_Interface.printWagerTicket(JSON.stringify(ticketJson));
      }
    }
  }
}
export function printDepositTicket({ clientType, ticketJson, callback, isPrintOut, dontShowDidIdPrintedModal }) {
  ticketJson.header = store.state.settings.terminalInfo.location.ticket_header;
  ticketJson.footer = store.state.settings.terminalInfo.location.ticket_footer;
  ticketJson.brand_description = 'SPORTSBOOK & KIOSK & WEB';
  ticketJson.time_stamp = convertTimeToCTAndFormatPrint(new Date());
  ticketJson.lang_amount = i18n.t('PrintTemplate.DepositTicket.zpl.amount');
  ticketJson.lang_ticketNumber = i18n.t('PrintTemplate.DepositTicket.zpl.ticketNumber');
  ticketJson.lang_warning = i18n.t('PrintTemplate.DepositTicket.zpl.warning');

  const currentRouteNameToRedirect = router.currentRoute.name;

  if (clientType === 'ELECTRON') {
    const printer_model = snq(() => store.state.settings.terminalInfo.printer.printer_model);

    console.log({ printer_model });

    if (!store.state.settings.terminalInfo.printer || printer_model === PRINTERS.Default) {
      callback({ success: true });
      router.push({
        name: 'clerk-ticket-deposit',
        query: { ...ticketJson, currentRouteNameToRedirect, isPrintOut, dontShowDidIdPrintedModal },
      });
    } else if (
      printer_model === PRINTERS.StarTSP100 ||
      printer_model === PRINTERS.EpsonTMP80 ||
      printer_model === PRINTERS.PoslineIT1260
    ) {
      callback({ success: true });
      router.push({
        name: 'clerk-ticket-deposit',
        query: { ...ticketJson, currentRouteNameToRedirect, isPrintOut, dontShowDidIdPrintedModal },
      });
    } else {
      // ZEBRA
      console.log('starting to print via usb printer');
      const ticket = createDepositTicket(ticketJson);
      console.log('deposit ticket:');
      console.log(ticket);
      printer.print(ticket, callback);
      store.dispatch('settings/setReprintModal', {
        show: true,
        scanCode: ticketJson.scan_code,
      });
    }
  } else if (clientType === 'ANDROID_TABLET') {
    console.log('starting to print via android tablet');
    if (typeof Epos_Android_Interface != 'undefined') {
      if (Epos_Android_Interface.printDepositTicket != 'undefined') {
        Epos_Android_Interface.printDepositTicket(JSON.stringify(ticketJson));
      }
    }
  }
}

export const printerPageUtils = () => {
  const makeFullPage = () => document.body.classList.add('full-page-print-hide-header');
  const makeNormalPage = () => document.body.classList.remove('full-page-print-hide-header');

  return {
    makeFullPage,
    makeNormalPage,
  };
};
